const updateATCButton = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  const timer = setInterval(() => {
    if (!atcButton.classList.contains('tee-processing')) {
      console.log('finished processing', atcButton);
      const innerSpan = atcButton.querySelector('span');
      const originHTML = innerSpan.innerHTML;
      innerSpan.innerHTML = `<div class="added-product-cart-msg">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 23" fill="none">
          <rect x="0.5" y="0.609985" width="21" height="21" rx="10.5" stroke="#363636" stroke-opacity="0.1"/>
          <path d="M16 8L9.125 15L6 11.8182" stroke="#363636" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Successfully added to cart</span>
      </div>`;
      setTimeout(() => {
        innerSpan.innerHTML = originHTML;
      }, 15000);
      clearInterval(timer);
      return;
    }
  }, 100);
}

const PRIO_PLUS_VARIANT_ID = '40735400722504'; // Set this in your theme settings
const PRIO_PLUS_QUANTITY = 1;

// Use Liquid to check the metafield
const excludePrioPlus = !!document.querySelector("[data-no-prio]")




async function handlePrioPlus() {
  try {
    // Get the current cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Check if Prio+ is already in the cart
    const prioPlusInCart = cart.items.some(item => item.variant_id.toString() === PRIO_PLUS_VARIANT_ID);

    if (excludePrioPlus && prioPlusInCart) {
      // Remove Prio+ if the new item excludes it
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: PRIO_PLUS_VARIANT_ID,
          quantity: 0,
          properties: {
            _is_cart_upsell : true
          }
        })
      })
    } else if (!excludePrioPlus && !prioPlusInCart) {
      // Add Prio+ if it's not in the cart and not excluded
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: PRIO_PLUS_VARIANT_ID,
            quantity: PRIO_PLUS_QUANTITY,
            properties: {
              _is_cart_upsell : true
            }
          }]
        })
      })
    }

    // Refresh the cart or mini-cart
    // This part depends on your theme's implementation
    // You might need to trigger a custom event or refresh a specific element
    //window.location.reload(); // Simple page refresh as a fallback
     window.teeinblueProductAdded();
  } catch (error) {
    console.error('Error modifying cart:', error);
    // Handle the error (e.g., show an error message to the user)
  }
}


const setPdpHeaderTimerStyle = (leftTime) => {
  let minute = Math.trunc(leftTime / 60);
  let second = leftTime % 60;
  if (second < 10) second = '0' + second;
  return minute + ':' + second + ' min';
}
let pdpHeaderTimers = [];
const endPdpHeaderTimer = (timer, pdpHeader, teeContainer) => {
  clearInterval(timer);
  pdpHeader.classList.remove('active');
  teeContainer.style.removeProperty('--tee-gallery-wrapper-top');
}
const startPdpHeaderTimer = (pdpHeader, teeContainer) => {
  Array.from(pdpHeaderTimers).forEach(pdpHeaderTimer => {
    endPdpHeaderTimer(pdpHeaderTimer, pdpHeader, teeContainer);
  });
  pdpHeader.classList.add('active');
  teeContainer.style.setProperty('--tee-gallery-wrapper-top', pdpHeader.offsetHeight - 1 + 'px');
  const timeSpan = pdpHeader.querySelector('[js-left-time]');
  let leftTime = 600;
  timeSpan.innerHTML = setPdpHeaderTimerStyle(leftTime);
  const timer = setInterval(() => {
    leftTime--;
    timeSpan.innerHTML = setPdpHeaderTimerStyle(leftTime);
    if (leftTime < 0) endPdpHeaderTimer(timer, pdpHeader, teeContainer);
  }, 1000);
  pdpHeaderTimers.push(timer);
}

const updateInfoForTeeGalleryWrapper = () => {
  const teeContainer = document.querySelector('.product--left.product--stacked');
  if (!teeContainer) return;
  const header = document.querySelector('.section-header');
  if (!header) return;
  if (document.querySelector('body').classList.contains('ab_test_pdp_flow_1')) {
    header.style.setProperty('position', 'sticky', 'important');
    header.style.setProperty('--header-wrapper-height', 0 + 'px');
    teeContainer.style.setProperty('--tee-gallery-wrapper-top', header.clientHeight - 1 + 'px');
  }
  if (document.querySelector('body').classList.contains('ab_test_pdp_flow_2')) {
    header.style.setProperty('position', 'sticky', 'important');
    teeContainer.style.setProperty('--tee-gallery-wrapper-top', header.clientHeight - 1 + 'px');
    const headerWrapper = header.querySelector('.header-wrapper');
    if (!headerWrapper) return;
    header.style.setProperty('--header-wrapper-height', headerWrapper.offsetHeight + 'px');
    const pdpHeader = header.querySelector('.pdp-header');
    if (!pdpHeader) return;
    startPdpHeaderTimer(pdpHeader, teeContainer);
  }
}

window.teeinblueProductAdded = function () {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then(res => res.json())
      .then(res => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
  }
  updateInfoForTeeGalleryWrapper();
  if (document.querySelector('body').classList.contains('ab_test_pdp_flow_2'))
    updateATCButton();
}

document.addEventListener('cart:item-removed', () => {
  const pdpHeader = document.querySelector('.pdp-header');
  const teeContainer = document.querySelector('.product--left.product--stacked');
  if (pdpHeaderTimers.length > 0 && pdpHeader && teeContainer)
    endPdpHeaderTimer(pdpHeaderTimers[0], pdpHeader, teeContainer);
});


document.addEventListener('teeinblue-event-after-cart-added', handlePrioPlus);

